import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { AuthorsList } from '../../articleComponents/author/AuthorsList';
import { H4, semanticCSS } from '../../../typography/semanticTags';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { BaseUnit } from '../../../theming/baseUnitDefinition';

export const componentConfigurationKey = 'articleTitle';

export interface ArticleAuthorTitleThemeProps {
    metaDataColor: string;
    baseUnit: BaseUnit;
    showTimestamp: boolean;
}

export interface ArticleAuthorsTitleProps {
    by: string;
    updatedText: string;
    authors: AuthorsList | null;
    updatedAt: string;
    updatedAtISO: string;
    showUpdatedAt: boolean;
    createdAt: string;
    createdAtISO: string;
}

const createStyle = ({ metaDataColor, baseUnit }: ArticleAuthorTitleThemeProps) => {
  return StyleSheet.create({
    wrapper: {
      marginTop: `${baseUnit * 0.5}px`,
    },
    metaData: {
      color: metaDataColor,
    },
    sidesPadding: {
      marginTop: `${baseUnit * 0.5}px`,
      marginLeft: 0,
      marginRight: `${baseUnit * 4}px`,
      [MEDIA_BREAKPOINTS.small]: {
        marginRight: `${baseUnit * 3}px`,
        marginLeft: `${baseUnit}px`,
      },
    },
  });
};

const shouldDisplayAuthors = (authors: AuthorsList | null) => {
  return authors && authors.length > 0;
};

export const ArticleAuthorsTitle: React.FunctionComponent<ArticleAuthorsTitleProps> = props => {
  const { by, updatedText, updatedAt, updatedAtISO, showUpdatedAt, createdAt, createdAtISO, authors } = props;
  const themeProps = useTheme<ArticleAuthorTitleThemeProps>(componentConfigurationKey);
  const { showTimestamp } = themeProps;
  const style = createStyle(themeProps);
  const hasAuthors = shouldDisplayAuthors(authors);
  const separator = hasAuthors ? ' | ' : '';

  return (
    <div className={css(style.wrapper)}>
      <H4 styles={semanticCSS(style.metaData, style.sidesPadding)}>
        {hasAuthors && <AuthorsList by={by} authors={authors} />}
        {showTimestamp ? <time dateTime={createdAtISO}>{`${separator}${createdAt}`}</time> : null}
        {showTimestamp && showUpdatedAt ? <time dateTime={updatedAtISO}>{` | ${updatedText} ${updatedAt}`}</time> : null}
      </H4>
    </div>
  );
};
